import {
  IGetComparisonDesktopResponse400,
  IGetComparisonDesktopResponseError,
} from '../../repositories/offers-comparison/v2/get-comparison-desktop';

export const mapComparisonResponseError = (
  response: IGetComparisonDesktopResponseError,
): IGetComparisonDesktopResponse400 => {
  return {
    statusCode: 400,
    headers: [],
    response: {
      errors: response.errors,
      message: response.message,
    },
  };
};
